const eventsTypeMap = new Map([
  [53, 'Vehículo apagado'],
  [69, 'Vehículo encendido'],
  [87, 'Batería principal conectada'],
  [80, 'Batería principal desconectada'],
  [44, 'Tiempo vehículo encendido'],
  [11, 'Tiempo vehículo apagado'],
  [204, 'Cambio de rumbo']
])

export {eventsTypeMap}



// WEBPACK FOOTER //
// ./src/utils/eventsType.js